import Backbone from 'backbone';
import MenuButonsView from '../view/menuButtonsView';
import MenuButtonsModel from '../models/menuButtons';

export default Backbone.View.extend({
  initialize(o) {
    this.model = o.model;
    this.menuButtonView = new MenuButonsView({
      collection: new MenuButtonsModel(this.model.get('buttons'))
    });
  },
  template: function({ title }) {
    this.$el.addClass('menu_gorup');
    if (title) {
      return `<div class="menu_group_title">${title}</div>`;
    } else {
      return ``;
    }
  },
  render() {
    this.$el.append(this.template(this.model.toJSON()));
    this.$el.append(this.menuButtonView.render().$el);
    return this;
  }
});
